export default {
  namespaced: true,
  state: {
    retailers: [],
    retailerCodes: []
  },
  getters: {
    getRetailers: state => {
      return state.retailers;
    },
    getRetailerCodes: state => {
      return state.retailerCodes;
    }
  },
  actions: {
    getRetailerList({ state, rootGetters }) {
      return rootGetters["network/getClient"]
        .get(`retailer/used-with-orders`)
        .then(response => {
          state.retailers = response.data;
        });
    },
    getRetailerCodesForMeasure({ state, rootGetters }) {
      return rootGetters["network/getClient"]
        .get(`retailercode/used-with-bodyprints`)
        .then(response => {
          state.retailerCodes = response.data;
        });
    },
    getRetailerCodesForOrders({ state, rootGetters }) {
      return rootGetters["network/getClient"]
        .get(`retailercode/used-with-orders`)
        .then(response => {
          state.retailerCodes = response.data;
        });
    }
  },
  mutations: {}
};
